export default __webpack_public_path__ + "static/timesheet-ad8f45c732394ac496419efbe5e72fc3.png";